/* Copyright(c) 2019 APSS Media Pvt. Ltd.
 *  All Rights Reserved
 */

/*@author :Sanjana Shende
 *@fileName :AddUserPublisher.js
 *Desc: Add User
 */

import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logoutUser } from "../login/authentication";
import { withRouter } from "react-router-dom";
import Footer from "../layouts/footer";
import PublisherNavigation from "../layouts/publisherNavPage";
import { Tooltip, Icon, Input, Table,Radio, } from "antd"; // Anshul-5727: imported Radio input
import { FaArrowAltCircleLeft } from "react-icons/fa";
import { css } from "emotion"; //Sandeep-task-3447-added css file
import "./addUserPublisher.css"; //Sandeep-task-3447-added css file
import { fetch_custom as fetch } from "../../configration/fetch_default_headers"; // karan-task-3723-vapt header and query params
import Picky from "react-picky";  //Anshul-5727: Added Picky dropdown for publisher names
//import { margins } from "pdfkit/js/page";
const Swal = require("sweetalert2");

const tableCSS = css({
  backgroundColor: "white",
   margin: "10px", //Anshul-5779
  boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px", //Anshul-
  

  
  "& thead > tr > th": {
    backgroundColor: "#144999", //rutuja task -4524 changed background color
    color: "white",
    fontWeight: "500",
    // wordWrap:"break-word",
    // width:'10%'
  },
  "& thead > tr": {
    borderWidth: "2px",
    borderStyle: "solid",
  },
}); //Sandeep-task-3447-added Tablecss file

class AddUserPublisher extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputClass11: "btn add-button",
      fields: {},
      errors: "",
      loader2: "",
      userDomain: "",
      selectedUserDomain: "@machbizz.com", //Sanjana-3192-For default domain in select dropdown in case user login with "machbizz.com"
      tableSearchText: "",//Aman-5454-added to store value for search
      userDetailsSearch: [],//Aman-5454-added search data array
      filterStatus: "activeUsers", //Anshul-5727: for storing active or deactivated radio button value
      activatedUsersCheckboxArray: [], //Anshul-5727: added to store the active users
      deactivatedUsersCheckboxArray: [], //Anshul-5727: added to store the deactivated users
      showPubMovePopup: false, //Anshul-5727: added move popup initially set as false
      selectedPublisher: null, //Anshul-5727: added to store the selected publisher's PID
      movePublisherArray: [], //Anshul-5727: Array to store the publishers whose orgID to be updated
      disableSaveButton: true, //Anshul-5727: disabled Save button until all input values are not filled
      selectedPublishers: [], // Anshul-5727: 
    };
    this.handleChange = this.handleChange.bind(this);
    this.submitUser = this.submitUser.bind(this);
    this.dropDownChange = this.dropDownChange.bind(this); //Sanjana-3192-handleChange function for dropdown in case user login with "machbizz.com"
    this.handleChangeSearch = this.handleChangeSearch.bind(this);//Aman-5454-added search function binding 
    this.handleMoveButtonClick = this.handleMoveButtonClick.bind(this); //Anshul-5727
    this.handleClosePopup = this.handleClosePopup.bind(this); //Anshul-5727
    this.handleBackButtonToDashboard = this.handleBackButtonToDashboard.bind(this);//Anshul-5927: added to handle back button to dashboard and lead review page

  } // end of constructor
  componentDidMount() {
    //  const { isAuthenticated, user } = this.props.auth;
    const { user } = this.props.auth; //Nilesh-2897-Removing console warnings
    //  let orgID = user.id; //Nilesh-2897-Removing console warnings
    var userName = user.name;
    userName = userName.split("@");
    var userName1 = "@" + userName[1];

    /* @author Sandeep Dhawale
     * @param  Description get user details
     * @return Description get user details
     */
    this.setState({ loader2: "loader_report1" });
    fetch("/users/getUserList", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    }) // karan-task-3723-vapt header and query params
      .then((res) => res.json())
      .then((getUserList) => {
        this.setState({ getUserList: getUserList, loader2: "" });
      })
      .catch(function (err) {
        console.log(err);
      });

    //Sanjana-3192-condition to display single/multiple domain suggestion in case user login with "machbizz.com"
    if (userName[1] === "machbizz.com" || userName[1] === "machbizz.co.in") {
      const selectAfter = (
        <select
          onChange={this.dropDownChange}
          style={{ backgroundColor: "#fafafa", border: "0px solid #d9d9d9" }}
        >
          <option selected name=".machbizz.com" value="@machbizz.com">
            @machbizz.com
          </option>
          <option name=".machbizz.co.in" value="@machbizz.co.in">
            @machbizz.co.in
          </option>
        </select>
      );
      this.setState({ userDomain: selectAfter });
    } else {
      this.setState({ userDomain: userName1 });
    }
    // end of componentDidMount
  }
   // Anshul-5927: handle back button behavior to dashboard and lead review page
  handleBackButtonToDashboard(e) {
    e.preventDefault();
    if (this.props.auth && this.props.auth.user && this.props.auth.user.role === "PC-TM") {
      this.props.history.push("/publisherInternalReviewLead", { pID: this.props.auth.user.id });
    } else {
      this.props.history.push("/newPublisherDashboard");
    }
  }
  //Sanjana-3192-handleChange function for dropdown in case user login with "machbizz.com"
  dropDownChange(e) {
    //  const { name, value } = e.target;
    const { value } = e.target; //Nilesh-2897-Removing console warnings

    this.setState({ selectedUserDomain: value });
  }
  validateForm() {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;
    let spanDisplay = "none";
    //  let requiredFeildValidate = "true";  //Nilesh-2897-Removing console warnings
    let requiredFeildValidate = true;
    //  let userNameValidate = "true"; //Nilesh-2897-Removing console warnings
    let userNameValidate = true;
    //  let firstNameValidate = "true";
    let firstNameValidate = true; //Nilesh-2897-Removing console warnings
    //  let lastNameValidate = "true"; //Nilesh-2897-Removing console warnings
    let lastNameValidate = true;
    //  let roleValidate = "true";  //Nilesh-2897-Removing console warnings
    let roleValidate = true;

    //Sanjana-3192-condition added in validation when user in case user login with "machbizz.com"
    if (
      this.state.selectedUserDomain === "" ||
      this.state.selectedUserDomain === "null" ||
      this.state.selectedUserDomain == null
    ) {
      fields["userName"] = fields["userName"] + this.state.userDomain;
    } else {
      fields["userName"] = fields["userName"] + this.state.selectedUserDomain;
    }
    this.setState({ fields });

    if (
      !fields["userName"] &&
      !fields["role"] &&
      !fields["firstName"] &&
      !fields["lastName"]
    ) {
      requiredFeildValidate = false;
      errors["commonError"] = <li>Please fill below required fields</li>;
      this.setState({ errors: errors });
    } else {
      if (
        this.state.userName === "" || //Nilesh-2897-Removing console warnings
        this.state.userName == null ||
        this.state.userName === undefined //Nilesh-2897-Removing console warnings
      ) {
        userNameValidate = false;
        //errors["userName"] = <li>Please enter user name</li>;
        errors["userName"] = <li>Please enter user name</li>;
        this.setState({ errors: errors });
      } else {
        //shivani - 3599 - changed RegEx as per validation requirement for hyphen .
        //  var pattern = new RegExp(/^([a-zA-Z]+[\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,3}(?:\.[a-z]{2})?)$/)
        // var pattern = new RegExp(/^\s*$|^[a-zA-Z0-9_%+]+[\w-]+[a-zA-Z0-9_%+]+(\.[a-zA-Z0-9]+)*@[a-zA-Z0-9]+[\w-]+[a-zA-Z0-9]+\.([a-zA-Z]{3,5}|[a-zA-z]{2,5}\.[a-zA-Z]{2,5})/)
        //sunita-task-3782-below regex accept only business domains.
        //Sandeep-task-3893-Production issue-Email format issue--All roles
        var pattern = new RegExp(
          // /^\s*$|^[a-zA-Z0-9_%+]+[\w-]+[a-zA-Z0-9_%+]+(\.[a-zA-Z0-9]+)*@[a-zA-Z0-9]+[\w-]+[a-zA-Z0-9]+\.([a-zA-Z]{3,5}|[a-zA-z]{2,5}\.[a-zA-Z]{2,5})/
          // eslint-disable-next-line no-useless-escape
          /^\s*$|^[\.a-zA-Z0-9_%+]+[\w-]+[a-zA-Z0-9_%+]+(\.[a-zA-Z0-9]+)*@(?!gmail.com)(?!gmail.co.in)(?!yahoo.com)(?!yahoo.co.in)(?!facebook.com)(?!facebook.co.in)[a-zA-Z0-9]+[\w-]+[a-zA-Z0-9]+\.([a-zA-Z]{3,5}|[a-zA-z]{2,5}\.[a-zA-Z]{2,5})/
        ); //mufiz 4091

        //var pattern = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        //var pattern = new RegExp(/^[a-zA-Z0-9]+.+[a-zA-Z0-9]+@+[a-zA-Z0-9]+.+[A-z]/);
        // var pattern = new RegExp(/^\s*$|^[a-zA-Z]+[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)*@[a-zA-Z0-9]+\.([a-zA-Z]{3,5}|[a-zA-z]{2,5}\.[a-zA-Z]{2,5})/);
        // 	if (!pattern.test(fields["userName"])) {
        // 		userNameValidate = false;
        // 		errors["userName"] = <li>Please enter valid user name</li>;
        // 		this.setState({ errors: errors });
        // 	} else {
        // 		errors["userName"] = "";
        // 		this.setState({ errors: errors });
        // 	}
        // } 
          // 5778-Kiran Dhainje -commented This Prod Issue-AC/PC/DC/ADV/AQA-Add User-Blank User Name accepting
        // if (this.state.userName.match(pattern)) {
        //   // mufiz Task-3984 Settings - Add User - Username should accept EmailID as per tooltip
        //   userNameValidate = true;
        //   // errors["userName"] =
        //   // this.setState({ errors: errors });
        // } else {
        //   userNameValidate = false;
        //   errors["userName"] = <li>Please enter valid user name</li>;
        //   this.setState({ errors: errors });
        // } // mufiz Task-3984 Settings - Add User - Username should accept EmailID as per tooltip

          // Added the confition for this 5778-Kiran Dhainje- This Prod Issue-AC/PC/DC/ADV/AQA-Add User-Blank User Name accepting

          if (!this.state.userName || /^\s*$/.test(this.state.userName)) {
            userNameValidate = false;
            errors["userName"] = <li>User name cannot be blank or spaces</li>;
          this.setState({ errors: errors });
        } else if (this.state.userName.match(pattern)) {
               // existing email regex check
                userNameValidate = true;
               } else {
               userNameValidate = false;
               errors["userName"] = <li>Please enter valid user name</li>;
                      this.setState({ errors: errors });
                   }
      }
      if (
        this.state.firstName === "" || //Nilesh-2897-Removing console warnings
        this.state.firstName == null ||
        this.state.firstName === undefined //Nilesh-2897-Removing console warnings
      ) {
        firstNameValidate = false;
        errors["firstName"] = <li>Please enter first name</li>;
        this.setState({ errors: errors });
      } else {
        let pattern = new RegExp(/^[a-zA-Z]+$/); //Nilesh-2897-Removing console warnings
        if (!pattern.test(fields["firstName"])) {
          userNameValidate = false;
          errors["firstName"] = <li>please enter valid first name</li>;
          this.setState({ errors: errors });
        } else {
          errors["firstName"] = "";
          this.setState({ errors: errors });
        }
      }
      if (
        this.state.lastName === "" || //Nilesh-2897-Removing console warnings
        this.state.lastName == null ||
        this.state.lastName === undefined //Nilesh-2897-Removing console warnings
      ) {
        lastNameValidate = false;
        errors["lastName"] = <li>Please enter last name</li>;
        this.setState({ errors: errors });
      } else {
        let pattern = new RegExp(/^[a-zA-Z]+$/); //Nilesh-2897-Removing console warnings
        if (!pattern.test(fields["lastName"])) {
          userNameValidate = false;
          errors["lastName"] = <li>please enter valid last name</li>;
          this.setState({ errors: errors });
        } else {
          errors["lastName"] = "";
          this.setState({ errors: errors });
        }
      }
      if (
        this.state.role === "" || //Nilesh-2897-Removing console warnings
        this.state.role == null ||
        this.state.role === undefined //Nilesh-2897-Removing console warnings
      ) {
        roleValidate = false;
        errors["role"] = <li>Please enter role</li>;
        this.setState({ errors: errors });
      } else {
        errors["role"] = "";
        this.setState({ errors: errors });
      }
    }

    if (
      //Nilesh-2897-Removing console warnings
      requiredFeildValidate === false ||
      userNameValidate === false ||
      firstNameValidate === false ||
      lastNameValidate === false ||
      roleValidate === false
    ) {
      formIsValid = false;
      this.setState({
        errors: errors,
        alertBorder: "1px solid red",
        alertWidth: "1000px",
        alertAlign: "center",
        alertDisplay: "block",
        spanSpaceDisplay: spanDisplay,
      });
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (
      //Nilesh-2897-Removing console warnings
      requiredFeildValidate === true || //// mufiz Task-3984 Settings - Add User - Username should accept EmailID as per tooltip
      userNameValidate === true ||
      firstNameValidate === true ||
      lastNameValidate === true ||
      roleValidate === true
    ) {
      formIsValid = true;
      // alert("success");
    }
    return formIsValid;
  }

  //Rutuja-5065-function for Active status route call
  // changeUserStatusActive(e, record) {
  //   var orgID = record.userID;
  //   //Priyanka-5438-Passing role
  //   var role = record.role;
  // 	let data = {
  // 	  orgID: orgID,
  // 	  role:role,
  //     userName : record.userName  //Priyanka-5468-Passing selected username to BE
  // 	};
  //   fetch("/users/setUserStatusActiveDIQA", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify(data),
  //   })
  //     .then((res) => res.json())
  //     .then((response) => {
  //       if (response.success === true) {
  //         Swal.fire({
  //           text: "User Activated",
  //           type: "success",
  //           confirmButtonText: "Ok",
  //           allowOutsideClick: false,
  //           preConfirm: () => {
  //             window.location.reload();
  //           },
  //         });
  //       }
  //       else{
  //         //Priyanka-x -Showing error message
  //         Swal.fire({
  //           text: "User Already exists",
  //           type: "error",
  //           confirmButtonText: "Ok",
  //           allowOutsideClick: false,
  //           preConfirm: () => {
  //             window.location.reload();
  //           },
  //         });
  //       }
  //       this.setState({ isDisabled: true });
  //     });
  // }

  //Anshul-5727: 
  changeUserStatusActive() {
    const { deactivatedUsersCheckboxArray } = this.state;

    if (
      !Array.isArray(deactivatedUsersCheckboxArray) ||
      deactivatedUsersCheckboxArray.length === 0
    ) {
      console.error("No active users selected for deactivation.");
      return;
    }

    const data = deactivatedUsersCheckboxArray.map((userID) => ({ userID }));

    fetch("/users/setUserStatusActiveDIQA", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.success === true) {
          Swal.fire({
            text: "User Activated",
            type: "success",
            confirmButtonText: "Ok",
            allowOutsideClick: false,
            preConfirm: () => {
              window.location.reload();
            },
          });
        } else {
          Swal.fire({
            text: "Some users could not be Activated.",
            type: "error",
            confirmButtonText: "Ok",
            allowOutsideClick: false,
            preConfirm: () => {
              window.location.reload();
            },
          });
        }
        this.setState({ isDisabled: true });
      })
      .catch((error) => {
        console.error("Error in deactivation request:", error);
      });
  }

  // handleChange(e) {
  //   let fields = this.state;

  //   fields[e.target.name] = e.target.value;
  //   this.setState({ fields });
  // }


  // Anshul-5727: updated handleChange to disable the save button untill all input value not filled
  handleChange(e) {
    let fields = this.state.fields;
    const { name, value } = e.target;
    fields[name] = value;

    const { userName, firstName, lastName, role } = fields;
    const isComplete =
      userName && firstName && lastName && role && role !== "None Selected";

    this.setState({
      fields,
      [name]: value,
      disableSaveButton: !isComplete,
    });
  }

  //Supriya: Submit User
  submitUser(e) {
    //  const self = this; //karan-task-3717-replace query params //Nilesh-2897-Removing console warnings
    //  const { isAuthenticated, user } = this.props.auth; //Nilesh-2897-Removing console warnings
    //Sanjana-3192-condition added to generate final data  when user in case user login with "machbizz.com"/ with "apssmedia.com"
    let data;
    // if(this.state.userDomain==="@apssmedia.com")
    //sunita-task-3782-changed below condition as per requirement
    if (this.state.userDomain) {
      data = {
        // userName: this.state.userName+this.state.userDomain,
        userName: this.state.userName,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        role: this.state.role,
      }; // karan-task-3723-vapt header and query params
    } else {
      data = {
        userName: this.state.userName + this.state.selectedUserDomain,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        role: this.state.role,
      }; // karan-task-3723-vapt header and query params
    }

    if (this.validateForm() === false) {
      return;
    } else {
      let errors = {};
      fetch("/users/addUserDetails", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((userDetails) => {
          if (userDetails.length > 0) {
            errors["sameUser"] = <li>User Already Exists</li>;
            this.setState({ errors: errors });
          } else {
            fetch("/users/addUser", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(data),
            })
              .then(function (response) {
                if (response.status >= 400) {
                  throw new Error("Bad response from server");
                }
                return response.json();
              })
              .then(function (response) {
                // success message with response
                if (response.success === true) {
                  //Nilesh-2897-Removing console warnings
                  Swal.fire({
                    text: "User Added Successfully",
                    type: "success",
                    confirmButtonText: "Ok",
                    allowOutsideClick: false,
                    preConfirm: () => {
                      // self.props.history.push("/newPublisherDashboard"); //karan-task-3717-replace query params
                      window.location.reload(); //Mufiz-3975-added code for refreshing the page.
                    },
                  });
                } else {
                }
              });
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    }
  }

  //kiran-4613-function call for update status
  // changeUserStatusInactive(e, record) {
  //   // const {name, value } = e.target; //Nilesh-2897-Removing console warnings
  //   // var orgID = record.userID
  //   var userID = record.userID;
  //   let data = {
  //     userID: userID,
  //   };
  //   fetch("/users/setUserStatusInactivePub", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify(data),
  //   })
  //     .then((res) => res.json())
  //     .then((response) => {
  //       if (response.success === true) {
  //         Swal.fire({
  //           text: "User Deactivated",
  //           type: "success",
  //           confirmButtonText: "Ok",
  //           allowOutsideClick: false,
  //           preConfirm: () => {
  //             window.location.reload();
  //           },
  //         });
  //       }
  //       this.setState({ isDisabled: true });
  //     });
  // }

  

  //Anshul-5727: above function sends single publisher so updated function below for sending array of publishers
  changeUserStatusInactive() {
    const { activatedUsersCheckboxArray } = this.state;

    if (
      !Array.isArray(activatedUsersCheckboxArray) ||
      activatedUsersCheckboxArray.length === 0
    ) {
      console.error("No active users selected for deactivation.");
      return;
    }

    const data = activatedUsersCheckboxArray.map((userID) => ({ userID }));

    fetch("/users/setUserStatusInactivePub", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.success === true) {
          Swal.fire({
            text: "User Deactivated",
            type: "success",
            confirmButtonText: "Ok",
            allowOutsideClick: false,
            preConfirm: () => {
              window.location.reload();
            },
          });
        } else {
          Swal.fire({
            text: "Some users could not be deactivated.",
            type: "error",
            confirmButtonText: "Ok",
            allowOutsideClick: false,
          });
        }

        this.setState({ isDisabled: true });
      });
  }

  //Aman-5454-added handleChangeSearch to Search user by firstName,lastName email & role
  handleChangeSearch(e) {
    e.preventDefault();
    let currentList = [];
    // Variable to hold the filtered list before putting into state
    let newList = [];
    let filterData = e.target.value;
    this.setState({filterData})//snehal-task-3574-Publisher side--my report-- filter issue
    // If the search bar isn't empty
    if (e.target.value.toString() === "") { //kiran-2836-Removing console warnings
      newList = this.state.getUserList;
    } else {
      // Assign the original list to currentList
      currentList = this.state.getUserList
      newList = currentList.filter((item) => {
        let obj={};//Somnath Task-3972, Add required comumn in search fields
        obj[`firstName`]=item.firstName;
        obj[`lastName`]=item.lastName;
        obj[`email`]=item.userName;
        obj[`role`]=item.role;
        // change current item to lowercase
        const lc = obj;
        //const lc = item.toLowerCase();
        // change search term to lowercase
        const filter = e.target.value.toLowerCase();
        var data = Object.values(lc);
        var dataFinal = data.toString();
        dataFinal = dataFinal.replace(",", " ");
        var dataToLower = dataFinal.toLowerCase();
        return dataToLower.includes(filter);
      });
    }
    // Set the filtered state based on what our rules added to newList
    this.setState({
      userDetailsSearch: [...newList],
      tableSearchText: filterData,
    });
  }

  // Anshul-5727: handling active and deactivated users using checkboxes
  handleCheckboxChange = (e, record) => {
    const {
      filterStatus,
      activatedUsersCheckboxArray,
      deactivatedUsersCheckboxArray,
    } = this.state;
    const isChecked = e.target.checked;
    const userID = record.userID;

    let arrayToUpdate =
      filterStatus === "activeUsers"
        ? activatedUsersCheckboxArray
        : deactivatedUsersCheckboxArray;

    const updatedArray = isChecked
      ? [...arrayToUpdate, userID]
      : arrayToUpdate.filter((id) => id !== userID);

    const newState =
      filterStatus === "activeUsers"
        ? { activatedUsersCheckboxArray: updatedArray }
        : { deactivatedUsersCheckboxArray: updatedArray };

    this.setState(newState);
  };

  // Anshul-5727: fetch all publisher list
  handleMoveButtonClick() {
 document.body.style.overflow = 'hidden';
    fetch("/users/getPublisherNameList", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => res.json())
      .then((publisherList) => {
        this.setState({ publisherList });
      })
      .catch(function (err) {
        console.log("Error fetching publisher list:", err);
      });

    this.setState({
      showPubMovePopup: true,
    });
  } // end fetch all publishers list

  handleClosePopup() {
 document.body.style.overflow = 'auto';  
   this.setState({
      showPubMovePopup: false,
    });
  }

 handleMovePublisherButton = () => {
  const {
    selectedPublishers,
    activatedUsersCheckboxArray,
    deactivatedUsersCheckboxArray,
  } = this.state;

  if (!selectedPublishers || selectedPublishers.length === 0) {
    Swal.fire({
      text: "Please select a publisher to move",
      type: "warning",
      confirmButtonText: "Ok",
    });
    return;
  }

const { getUserList } = this.state;

let selectedUserIDs = [];
if (activatedUsersCheckboxArray.length > 0) {
  selectedUserIDs = activatedUsersCheckboxArray;
} else if (deactivatedUsersCheckboxArray.length > 0) {
  selectedUserIDs = deactivatedUsersCheckboxArray;
} else {
  Swal.fire({
    text: "No users selected to move",
    type: "warning",
    confirmButtonText: "Ok",
  });
  return;
}

const selectedUsers = getUserList.filter(user =>
  selectedUserIDs.includes(user.userID)
);

const moveToPublisherID = selectedPublishers.map((p) => ({
  pID: p.pID,
  publisherName: p.publisherName,
  email:p.email,
}));


  fetch("/users/updatePublisherOrgID", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    users: selectedUsers,
    moveToPublisherID,
  }),
})
    .then((res) => res.json())
    .then((response) => {
      if (response.success === true) {
        Swal.fire({
          text: "Users Updated Successfully",
          type: "success",
          confirmButtonText: "Ok",
          allowOutsideClick: false,
          preConfirm: () => {
            window.location.reload();
          },
        });
      } else {
        Swal.fire({
          text: "Users Not Updated",
          type: "error",
          confirmButtonText: "Ok",
          allowOutsideClick: false,
        });
      }

      this.setState({ showPubMovePopup: false });
    })
    .catch((error) => {
      console.error("Error in Update request:", error);
    });
};


  render() {
    const asterisk = {
      color: "red",
    };
    //Sandeep-task-3447-added table to get user details
    const addUserPublisher = [
      // Anshul-5707: added checkboxes for each record
      {
        title: "",
        dataIndex: "",
        key: "checkbox",
        width: 30,
        align: "center",
        render: (text, record) => {
          const isUserAlreadyActive = this.state.getUserList.some(
            (u) =>
              u.userName === record.userName &&
              u.role === record.role &&
              (u.status === "Y" || u.status === null || u.status === "")
          );

          const isDeactivatedView =
            this.state.filterStatus === "deactivatedUsers";
          const shouldDisableCheckbox =
            isUserAlreadyActive && isDeactivatedView;

          const isChecked =
            this.state.filterStatus === "activeUsers"
              ? this.state.activatedUsersCheckboxArray.includes(record.userID)
              : this.state.deactivatedUsersCheckboxArray.includes(
                  record.userID
                );

          const checkbox = (
            <input
              type="checkbox"
              checked={isChecked}
              disabled={shouldDisableCheckbox}
              onChange={(e) =>
                !shouldDisableCheckbox && this.handleCheckboxChange(e, record)
              }
              style={{
                width: "20px",
                height: "20px",
                cursor: shouldDisableCheckbox ? "not-allowed" : "pointer",
                accentColor: "#0A61AD",
              }}
            />
          );

          return (
            <div>
              {shouldDisableCheckbox ? (
                <Tooltip title="User is already active with this role">
                  <span>{checkbox}</span>
                </Tooltip>
              ) : (
                checkbox
              )}
            </div>
          );
        },
      }, //Anshul-5727: end checkbox

      {
        title: "ID",
        dataIndex: "ID",
        key: "ID",
        width: 50,
        align: "Center", //Anshul-5727
        render: (text, record) => (
          <div>
            <span style={{ fontSize: "14px" }}>{record.userID}</span>
          </div>
        ),
      },
      {
        title: "First Name",
        dataIndex: "firstName",
        key: "firstName",
        width: 100,
        align: "Center", //Anshul-5727
        render: (text, record) => (
          <div>
             {/*Anshul-5727 */}
            {/* <div style={{ fontSize: "14px", width: "110px" }}>
              {record.firstName}
            </div> */}
            <div style={{ fontSize: "14px" }}>{record.firstName}</div>
          </div>
        ),
      },
      {
        title: "Last Name",
        dataIndex: "lastName",
        key: "lastName",
        width: 100,
        align: "Center", //Anshul-5727
        render: (text, record) => (
          <div>
            <div class="word-wrap" style={{ fontSize: "14px" }}>
              {record.lastName}
            </div>
          </div>
        ),
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
        width: 160,
        align: "Center", //Anshul-5727
        render: (text, record) => (
          <div>
            <span style={{ fontSize: "14px" }}>{record.userName}</span>
          </div>
        ),
      },
      {
        title: "Role",
        dataIndex: "role",
        key: "role",
        width: 50,
        align: "Center",
        render: (text, record) => (
          <div>
            <span style={{ fontSize: "14px" }}>{record.role}</span>
          </div>
        ),
      },
      //kiran-4613- added status and action column
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        width: 40,
        align: "center",
        render: (text, record) => (
          <div>
            <span
              style={{
                fontSize: "14px",
                fontWeight: "bold",
                color: record.status === "N" ? "red" : "green",
              }}
            >
              {record.status === "N" ? "Deactivated" : "Active"}
            </span>
          </div>
        ),
      },

      // Anshul-5727: removed action column from table
      // {
      //   title: "Action",
      //   dataIndex: "Action",
      //   key: "Action",
      //   width: 40,
      //   align: "Center",
      //   render: (text, record) => (
      //     <div>
      //       {/* Aman-4961-added record.status === "" to PC  user with empty user status can Deactive user */}
      //       {record.status === "Y" ||
      //       record.status === null ||
      //       record.status === "" ? (
      //         // Chaitanya-5088-change deactivate button alignment
      //         <button
      //           style={{ padding: "7px 7px", margin: "auto" }}
      //           className={this.state.inputClass11}
      //           onClick={(e) => this.changeUserStatusInactive(e, record)}
      //           // disabled={this.state.isDisabled}
      //           type="submit"
      //         >
      //           Deactive{" "}
      //         </button>
      //       ) : (
      //         //Rutuja-5065-change button to activate login
      //         <button
      //           style={{ padding: "7px 7px", margin: "auto" }}
      //           className={this.state.inputClass11}
      //           onClick={(e) => this.changeUserStatusActive(e, record)}
      //           //disabled='disabled'
      //           type="submit"
      //         >
      //           Activate{" "}
      //         </button>
      //       )}
      //     </div>
      //   ),
      // },
    ];

    const { getUserList, userDetailsSearch, tableSearchText, filterStatus } =
      this.state;

    let filteredData = tableSearchText === "" ? getUserList : userDetailsSearch;

    filteredData = filteredData?.filter((user) => {
      const isActive =
        user.status === "Y" || user.status === null || user.status === "";
      return filterStatus === "activeUsers" ? isActive : !isActive;
    });

    return (
      <div>
        <PublisherNavigation />
        <div class="container-fluid" style={{ paddingTop: "100px" }}>
          <div class="row">
            {/*mufiz-task-397 add new back button*/}
            <div class="col-lg-4" style={{ paddingLeft: "20px" }}>
              <a href="#/" onClick={this.handleBackButtonToDashboard} style={{ color: "#056eb8" }}>
                <FaArrowAltCircleLeft size={32} style={{ float: "left" }} title={this.props.auth.user.role === "PC-TM" ? "" : "Back to Dashboard"} />
              </a>
            </div>
          </div>

          {/* /*Sanjana-task-4118-added below css as per requirement*/}
          <h2 align="center" id="labelDI" style={{ marginTop: "-31px" }}>
            {/* Anshul-5727: changed page heading */}
            {/* Add User Details  */}
            {/* Anshul-5779: changed page title */}
           Add/Manage User
          </h2>
          <div
            class="card-body"
            className="cardBodyClass pubcardBodyClass"
            style={{
              margin: "10px",
              backgroundColor: "#fff",
              borderRadius: "4px",
              boxShadow: "grey 1px 1px 6px 0px", //mufiz-task-3975 styling a box
            }}
          >
            {/* <legend className="legend labelsubheading">User Details</legend> */}
            {/* //shivani-3284-passed ID for DI label consistency */}
            {/*Anshul-5727: commented below div */}
            {/* <div class="col-12" style={{ textAlign: "center" }}></div> 

            <div style={{ fontSize: "14px", color: "red" }}>
              {this.state.errors.commonError}
            </div>
            <div
              className="errorMsg"
              style={{ fontSize: "14px", color: "red" }}
            >
              {this.state.errors.userName}
              {this.state.errors.role}
              {this.state.errors.firstName}
              {this.state.errors.lastName}
              {this.state.errors.sameUser}
            </div> */}
            {/* <div class="row">  */}{" "}
            {/* anshul-5727: added new div to show fields in one row */}
            <div
              className="user-input-container"
              style={{
                display: "flex",
                gap: "75px",
                alignItems: "flex-end",
                flexWrap: "wrap",
              }}
            >
              {" "}
              {/* anshul-5727: added new div to combine all fields in one row */}
              {/* <div class="col-xs-12 col-sm-12 col-md-2 col-lg-4" >
				  <label id="label">User Name <span style={asterisk}>*&nbsp; 
				  <Tooltip title=" User name should be Valid Email Id.">
				  <Icon type="question-circle-o" />
				</Tooltip></span></label>
				  <input
					value={this.state.userName}
					onChange={this.handleChange}
					type="text"
					id="userName"
					className="form-control"
					name="userName"
					style={{ width: "60%", height: "60%" }}
					required />
				</div> */}
              {/* <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"> */}{" "}
              {/* anshul-5727 : commented above div and added new div */}
              <div style={{ flex: 1 }}>
                {" "}
                {/*Anshul-5727:  Updated to col-md-2 for 5 equal columns */}
                <label id="label">
                  User Name{" "}
                  <span style={asterisk}>
                    *&nbsp;
                    <Tooltip title=" User name should be Valid Email Id.">
                      <Icon
                        type="question-circle-o"
                        className="iconbackground"
                      />
                      {/*sunita-task-3818-added classname as per requirement for removing white patches */}
                    </Tooltip>
                  </span>
                </label>
                {/* <br /> */}
                {/* Anshul-5727: removed react Input and added HTML input */}
                {/* Kiran Dhainje-5778:Added the condtion for not accepect the space. Prod Issue-AC/PC/DC/ADV/AQA-Add User-Blank User Name accepting */}
                <input
                  // addonAfter={this.state.userDomain} //sunita-task-3782-commented this attribute as want to enable the domain field.
                  value={this.state.userName}
                  onChange={this.handleChange}
                  onKeyDown={(e)=>{
                    if(e.key===" ")e.preventDefault();
                  }} 
                  type="text"
                  id="PubuserName" //Chaitanya-4286-R-28.9- Prod issue-Publisher side-setting-add user
                  className="form-control"
                  name="userName"
                  style={{
                    width: "100%",
                    height: "60%",
                    borderRadius: "10px",
                    boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
                  }} // Anshul-5727: changed width from 60% to 100%, removed padding
                  required
                ></input>
              </div>
              {/* <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 Proleinputbox"> */}
              {/* Anshul-5727: comment above div and added new with flex 1 */}
              {/* </div> */}{" "}
              {/* anshul-5727: commented div to show fields in one row */}
              {/* <br /> */}
              {/* end of 1st row */}
              {/* <div class="row"> */}{" "}
              {/* anshul-5727: commented div to show fields in one row */}
              {/* <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"> */}
              <div style={{ flex: 1 }}>
                {" "}
                {/*Anshul-5727:  Updated to col-md-2 for 5 equal columns */}
                <label id="label">
                  First Name <span style={asterisk}>*</span>
                </label>
                <input
                  value={this.state.firstName}
                  onChange={this.handleChange}
                  type="text"
                  id="firstName"
                  className="form-control"
                  name="firstName"
                  style={{
                    width: "100%",
                    height: "60%",
                    borderRadius: "10px",
                    boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
                  }} // Anshul-5727: Set width to 100%, removed padding
                  required
                />
              </div>
              {/* <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 Proleinputbox"> */}
              <div style={{ flex: 1 }}>
                {" "}
                {/*Anshul-5727:  Updated to col-md-2 for 5 equal columns */}
                <label id="label">
                  Last Name <span style={asterisk}>*</span>
                </label>
                <input
                  value={this.state.lastName}
                  onChange={this.handleChange}
                  type="text"
                  id="lastName"
                  className="form-control"
                  name="lastName"
                  style={{
                    width: "100%",
                    height: "60%",
                    borderRadius: "10px",
                    boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
                  }} // Anshul-5727: Set width to 100%, removed padding
                  required
                />
              </div>
              <div style={{ flex: 1 }}>
                {" "}
                {/*Anshul-5727:  Updated to col-md-2 for 5 equal columns */}
                {/*sunita-task-3782-added classname as per requirement */}
                <label id="label">
                  Role <span style={asterisk}>*</span>
                </label>
                <select
                  value={this.state.role}
                  onChange={this.handleChange}
                  type="text"
                  id="role"
                  className="form-control"
                  name="role"
                  style={{
                    width: "100%",
                    height: "60%",
                    borderRadius: "10px",
                    boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
                  }}
                  required
                >
                 {/* Anshul-5907: showing only publisher telemarketing and publisher non-comm tel roles in dropdown */}
                  {this.props.auth.user.role === "PC-TM" ? (
                    <>
                      <option value="None Selected" disabled selected>
                        None Selected
                      </option>
                      <option value="PC-TM">Publisher Telemarketing</option>
                      <option value="PNC-TM">Publisher Non-Commercial Telemarketing</option>
                    </>
                  ) : (
                    <>
                      <option value="None Selected" disabled selected>
                        None Selected
                      </option>
                      <option value="PC">Publisher Commercial</option>
                      <option value="PNC">Publisher Non-Commercial</option>
                      <option value="PC-ACCOUNT">Accounting</option>
                      <option value="PQA">Quality Assurance</option>
                    </>
                  )}
                </select>
              </div>
              <div style={{ flex: 1 }}>
                {" "}
                {/*Anshul-5727:  Updated to col-md-2 for 5 equal columns */}
                <Tooltip
                  title={
                    this.state.disableSaveButton
                      ? "All fields marked with * are mandatory"
                      : ""
                  }
                >
                  <span>
                    <button
                      style={{
                        width: "40%",
                        margin: "0px",
                        marginLeft: "50px",
                        borderRadius: "10px",
                        boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
                      }}
                      className="btn add-button buttonSave"
                      onClick={this.submitUser}
                      type="submit"
                      disabled={this.state.disableSaveButton}
                    >
                      Add
                    </button>
                  </span>
                </Tooltip>
              </div>
            </div>
            {/* </div> */}{" "}
            {/* anshul-5727: commented div to show fields in one row */}
            {/* end of 2nd row */}
            {/* <br /> */} {/* Anshul-5727:*/}
            {/* locale={this.state.loading1?locale:"No Data"} */}
            {/* pagination={{ pageSize: this.state.pageSize1 }} */}
            {/* Anshul-5721: added error message below input fields */}
            <div class="col-12" style={{ textAlign: "center" }}></div>
            <div style={{ fontSize: "14px", color: "red" }}>
              {this.state.errors.commonError}
            </div>
            <div
              className="errorMsg"
              style={{ fontSize: "14px", color: "red", marginTop: "10px" }}
            >
              {this.state.errors.userName}
              {this.state.errors.role}
              {this.state.errors.firstName}
              {this.state.errors.lastName}
              {this.state.errors.sameUser}
            </div>
          </div>

          {/* end of card body */}
        </div>
        {/* end of container-fluid */}
        {/* <div className="d-flex justify-content-end"> */}{" "}
        {/*Anshul-5727: changed class to place radio buttons at right and search input at right  */}
        <div className="d-flex justify-content-between align-items-center flex-wrap"
          style={{ width: "100%" }}>
          {/* Anshul-5727: added radio buttons for active users and deactivated users */}
          <div style={{ marginLeft: "15px", marginTop: "15px" }}>
            <Radio.Group
              className="lead-radio"
              value={this.state.filterStatus}
              onChange={(e) => {
                const selectedFilter = e.target.value;
                this.setState({
                  filterStatus: selectedFilter,
                  activatedUsersCheckboxArray:
                    selectedFilter === "deactivatedUsers"
                      ? []
                      : this.state.activatedUsersCheckboxArray,
                  deactivatedUsersCheckboxArray:
                    selectedFilter === "activeUsers"
                      ? []
                      : this.state.deactivatedUsersCheckboxArray,
                });
              }}
            >
              {/* Anshul-5727: start move popup */}
              {this.state.showPubMovePopup && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: 9999,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    onClick={(e) => e.stopPropagation()}
                    style={{
                      backgroundColor: "#fff",
                      padding: "20px",
                      borderRadius: "10px",
                      width: "700px",
                      maxHeight: "70vh",
                      overflowY: "auto",
                      boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
                    }}
                  >
                    <div
                      style={{ display: "flex", gap: "20px", margin: "30px" }}
                    >
                      {/* select publisher dropdown */}
                      <div style={{ flex: 1 }}>
                        <label id="label">
                          Select Publisher:<span style={asterisk}>*</span>
                        </label>
                        <Picky
                          value={this.state.selectedPublishers}
                          options={this.state.publisherList || []}
                          onChange={(selected) =>
                            this.setState({ selectedPublishers: selected })
                          }
                          multiple={true}
                          dropdownHeight={250}
                          labelKey="publisherName"
                          valueKey="pID"
                        />
                      </div>

                      <div
                        style={{
                          width: "1px",
                          height: "300px",
                          backgroundColor: "#bababa",
                        }}
                      ></div>

                      {/* selected publishers */}
                      <div style={{ flex: 1 }}>
                        <label id="label">Selected Publisher:</label>

                        {this.state.selectedPublishers.length === 0 ? (
                          <div style={{ marginTop: "10px", color: "#888" }}>
                            No Publisher selected
                          </div>
                        ) : (
                          <ul style={{ marginTop: "10px" }}>
                            {this.state.selectedPublishers.map((pub, index) => (
                              <li key={index}>{pub.publisherName}</li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>

                    {/* start move and cancel  button */}
                    <div
                      style={{
                        textAlign: "right",
                        paddingRight: "1%",
                        //   marginBottom: "-3%",
                      }}
                    >
                                           {this.props.auth.user.role !== "PC-TM" && (
                        <div
                          style={{
                            position: "relative",
                            display: "inline-block",
                          }}
                        >
                          <button
                            type="submit"
                            className="btn"
                            onClick={this.handleMovePublisherButton}
                            style={{
                              backgroundImage:
                                "linear-gradient(to left, #0777cb, #103784)",
                              color: "white",
                              padding: "0px",
                              width: "100px",
                              height: "30px",
                              marginLeft: "10px",
                              borderRadius: "10px",
                              boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
                            }}
                            disabled={this.state.selectedPublishers.length === 0}
                          >
                            Switch Team
                          </button>
                        </div>
                      )}


                      <button
                        className="btn"
                        type="submit"
                        onClick={this.handleClosePopup}
                        style={{
                          marginLeft: "10px",
                          backgroundColor: "red",
                          color: "white",
                          height: "30px",
                          width: "100px",
                          padding: "0px",
                          borderRadius: "10px",
                          boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
                        }}
                      >
                        Cancel
                      </button>
                    </div>

                    {/* end move and cancel  button */}
                  </div>
                </div> //main div
              )}

              {/* Anshul-5727 end move popup */}

              {/* Anshul-5727: added radio buttons */}

              <Radio value="activeUsers" id="activeUsers">
                Active Users
              </Radio>
              <Radio value="deactivatedUsers" id="deactivatedUsers">
                Deactivated Users
              </Radio>
            </Radio.Group>
          </div>

          {/* //Aman-5454-added input for serach*/}

          {/* <div class="col-6 col-sm-6 col-md-6 col-lg-3 col-xl-2" style={{display:"flex", alignItems:"center"}}> */}
          <div className="col-6 col-sm-6 col-md-6 col-lg-3 col-xl-2 d-flex align-items-center">
            {" "}
            {/* Anshul-5727: */}
            <Tooltip title="Find the user's by Email/First Name/Last Name or role.">
              <Icon
                type="question-circle-o"
                className="iconbackground"
                style={{ marginTop: "10px" }}
              />
            </Tooltip>
            &nbsp;&nbsp;
            <input
              type="text"
              id="search_pub_myreport"
              className="form-control search_pub_myreport"
              value={this.state.filterData}
              onChange={this.handleChangeSearch}
              placeholder="Search..."
              title="Search"
              style={{
                backgroundImage: "url(searchIcon.png)",
                backgroundPosition: "15px 6px",
                backgroundSize: "15px 15px",
                backgroundRepeat: "no-repeat",
                height: "20px",
                fontSize: "12px",
                borderRadius: "25px", //Anshul-5727: Increases the border radius
                border: "1px solid rgb(221, 221, 221)",
                padding: "16px 20px 16px 34px",
                marginTop: "10px",
                boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
              }}
            />
          </div>
        </div>
        <br></br>
        <p>
          {this.state.tableSearchText === "" ? (
            <Table
              {...this.state.tableState}
              bordered
              dataSource={filteredData}
              rowKey="campID"
              columns={addUserPublisher}
             className={`${tableCSS} "ant-table-thead"`}ant-pagination ant-table-pagination
              scroll={{ y: 250 }}
            />
          ) : (
            <Table
              {...this.state.tableState}
              bordered
              dataSource={filteredData}
              rowKey="campID"
              columns={addUserPublisher}
              className={`${tableCSS} "ant-table-thead table-responsive"`}
            
            />
          )}
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "20px",
            marginTop: "20px",
            marginRight: "20px",
          }}
        >
          {/* Anshul-5779: hides the button for deactivated users and changed the position of the buttons */}
           {/* Anshul-5907:added this condition to navigate on leadReveiw page for pc-tm role */}
          {this.state.filterStatus === "activeUsers" && this.props.auth.user.role !== "PC-TM" && (
            <button
              className="btn add-button buttonSave"
              type="submit"
              disabled={this.state.activatedUsersCheckboxArray.length === 0}
              style={{
                width: "120px",
                borderRadius: "10px",
                boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
              }}
              onClick={this.handleMoveButtonClick}
            >
              Switch Team
            </button>
          )}
          {this.state.filterStatus === "deactivatedUsers" ? (
            <button
              className="btn add-button buttonSave"
              type="submit"
              disabled={this.state.deactivatedUsersCheckboxArray.length === 0}
              onClick={() => this.changeUserStatusActive()}
              style={{
                width: "120px",
                borderRadius: "10px",
                boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
              }}
            >
              Activate
            </button>
          ) : (
            <button
              className="btn add-button buttonSave"
              type="submit"
              disabled={this.state.activatedUsersCheckboxArray.length === 0}
              onClick={() => this.changeUserStatusInactive()}
              style={{
                width: "120px",
                borderRadius: "10px",
                boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
              }}
            >
              Deactivate
            </button>
          )}
  

        </div>
        <br></br>
        <br></br>
        <Footer />
      </div>
    );
  } // end of render
} // end of class

/**
 * @author Narendra Phadke
 * @param  Description handle the login authentication
 * @return Description return All details of authentication
 */
AddUserPublisher.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});
export default connect(mapStateToProps, { logoutUser })(
  withRouter(AddUserPublisher)
);
